var map = {
	"./badge.svg": 1116,
	"./chat.svg": 1117,
	"./check.svg": 1118,
	"./checked-circle.svg": 1119,
	"./checked-icon.svg": 1120,
	"./checkmark.svg": 1121,
	"./close-fill.svg": 1122,
	"./close-outline.svg": 1123,
	"./close.svg": 1124,
	"./comment.svg": 1125,
	"./comments.svg": 1126,
	"./consultation-deselected.svg": 1127,
	"./dashboard.svg": 1128,
	"./facebook-circle.svg": 1129,
	"./facebook.svg": 1130,
	"./funnel.svg": 1131,
	"./getcall.svg": 1132,
	"./google.svg": 1133,
	"./hide.svg": 1134,
	"./horn.svg": 1135,
	"./loader-spinner.svg": 1136,
	"./lock.svg": 1137,
	"./money-transfer.svg": 1138,
	"./new-projects.svg": 1139,
	"./pending-projects.svg": 1140,
	"./play-active.svg": 1141,
	"./play-inactive.svg": 1142,
	"./projects-in-progress.svg": 1143,
	"./questionmark.svg": 1144,
	"./show.svg": 1145,
	"./stripe.svg": 1146,
	"./support.svg": 1147,
	"./twitter.svg": 1148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1115;